import axios from 'axios';
export default (providerId, patientProfileId, dueDateTime, duration, paymentToken, organizationId) => {
  const promise = new Promise((resolve, reject) => {
    console.log('organizationId', organizationId);
    axios
      .post(process.env.VUE_APP_GATEWAY_ENDPOINT + 'v3/users/appointments', {
        due: dueDateTime,
        payment_token: paymentToken,
        provider_profile_id: providerId,
        patient_profile_id: patientProfileId,
        reserved_duration: duration,
        location_id: 0, // online
        organization_id: organizationId || 9999, // 9999 is B2C
        topics: [],
      })
      .then((data) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
